import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { useCallback, useMemo } from 'react';
import { toast } from 'react-toastify';
import ClearFilters from 'src/assets/icons/ClearFilters';
import Button from 'src/components/design-system/Button';
import useInvoiceScanManager from 'src/hooks/useInvoiceScanManager';
import { modifyRequest } from 'src/utils/requestInterceptor';
import {
  invoiceOcrDeleteAvailableCategories,
  useOcrScanCategories,
} from '../InvoiceScanManagerCategories';
import { initialOcrDataState } from '../InvoiceScanManagerContext';
import OcrDelete from './OcrDelete';

const OcrQueueTableToolBar = () => {
  const {
    ocrDataState,
    setOcrDataState,
    ocrDropdownFilter,
    setOcrDropdownFilter,
    ocrFilterInitialState,
  } = useInvoiceScanManager();
  const ocrCategories = useOcrScanCategories();

  const isClearFilterDisabled = useMemo(
    () =>
      !ocrDataState.filter?.filters.length &&
      ocrDropdownFilter.value === ocrFilterInitialState.value,
    [ocrDataState.filter?.filters.length, ocrDropdownFilter.value, ocrFilterInitialState.value]
  );

  const clearFilter = useCallback(() => {
    setOcrDataState(initialOcrDataState);
    setOcrDropdownFilter(ocrFilterInitialState);
  }, [ocrFilterInitialState, setOcrDataState, setOcrDropdownFilter]);

  const handleFilterChange = useCallback(
    (event: DropDownListChangeEvent) => {
      setOcrDropdownFilter(event.value);
      setOcrDataState((prev) => {
        if (modifyRequest(prev).filters.length) {
          toast.info('Preset filter applied. User-applied filters cleared.');
        }
        return {
          ...prev,
          filter: {
            logic: 'and',
            filters: [],
          },
        };
      });
    },
    [setOcrDataState, setOcrDropdownFilter]
  );

  return (
    <div className="flex items-center justify-between w-full">
      <div className="flex items-center gap-1">
        <Button
          endIcon={<ClearFilters />}
          color="transparent"
          onClick={clearFilter}
          className={isClearFilterDisabled ? '!bg-transparent' : ''}
          disabled={isClearFilterDisabled}
        >
          Clear Filters
        </Button>
        {invoiceOcrDeleteAvailableCategories.includes(ocrDropdownFilter.value) && <OcrDelete />}
      </div>
      <DropDownList
        id="view-drop-down-list"
        style={{ width: 190 }}
        data={ocrCategories}
        textField="label"
        dataItemKey="value"
        value={ocrDropdownFilter}
        onChange={handleFilterChange}
      />
    </div>
  );
};

export default OcrQueueTableToolBar;
